import React from 'react'
import ReportWrapper from '../ReportWrapper'
import { Stack, Table, Text, Title } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import ReportSectionHeading from '../ReportSectionHeading'
import { IconAlertTriangleFilled } from '@tabler/icons-react'

interface BasicDetailProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function BasicDetail({ data, title, sectionIndex }: BasicDetailProps) {
  const theme = useTheme()

  const basicInfoItems = [
    { label: '身份证号', value: data?.basic_info_id_card },
    { label: '身份证发放地', value: data?.basic_info_id_card_zone },
    { label: '手机号', value: data?.basic_info_phone },
    { label: '手机号归属地', value: data?.basic_info_phone_zone },
    { label: '性别', value: data?.basic_info_sex === 1 ? '男' : '女' },
    { label: '年龄', value: data?.basic_info_age ? `${data.basic_info_age}岁` : undefined },
    {
      label: '手机号检测结果',
      value: data?.basic_info_check === '1' ? '被查询人姓名与运营商提供的一致' : '被查询人姓名与运营商提供的不一致',
      emphasize: data?.basic_info_check !== '1',
    },
  ]

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Stack gap="md">
          <div className="flex flex-col gap-2">
            <Text size="xs" style={{ color: theme.accentTextColor, letterSpacing: '0.2em' }}>
              基础信息
            </Text>
            <Title order={3} style={{ color: theme.primaryColor }}>
              {data?.basic_info_name || '—'}
            </Title>
            <Text size="sm" className="text-gray-600">
              该信息来源于权威实名认证渠道,仅对本报告负责。如发现信息缺失或有误,建议联系客户确认。
            </Text>
          </div>

          <Table
            highlightOnHover
            verticalSpacing="sm"
            withColumnBorders={false}
            styles={{
              table: { fontSize: '13px', tableLayout: 'fixed' },
              th: {
                backgroundColor: theme.surfaceMutedColor,
                color: theme.accentTextColor,
                whiteSpace: 'nowrap',
                fontWeight: 600,
              },
            }}
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th style={{ width: '40%' }}>项目</Table.Th>
                <Table.Th style={{ width: '60%' }}>信息</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {basicInfoItems.map((item) => {
                const displayValue = item.value || '—'
                return (
                  <Table.Tr key={item.label}>
                    <Table.Td>{item.label}</Table.Td>
                    <Table.Td>
                      <div className="flex items-center gap-2">
                        {item.emphasize && <IconAlertTriangleFilled size={16} color={theme.warningColor} />}
                        <Text
                          size="sm"
                          fw={item.emphasize ? 600 : 500}
                          style={{
                            color: item.emphasize ? theme.warningColor : theme.primaryColor,
                          }}
                        >
                          {displayValue}
                        </Text>
                      </div>
                    </Table.Td>
                  </Table.Tr>
                )
              })}
            </Table.Tbody>
          </Table>
        </Stack>
      </div>
    </ReportWrapper>
  )
}
